import { render } from "./Multiple.vue?vue&type=template&id=f18cea88"
import script from "./Multiple.vue?vue&type=script&lang=js"
export * from "./Multiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__